import { isAuthConfigured, supabase } from '@/lib/supabase'

/** Wait for Supabase session hydration before API fetches on cold load. */
export async function waitForAccessToken(timeoutMs = 5000): Promise<boolean> {
  if (!isAuthConfigured || !supabase) return true
  const deadline = Date.now() + timeoutMs
  while (Date.now() < deadline) {
    const {
      data: { session },
    } = await supabase.auth.getSession()
    if (session?.access_token) return true
    await new Promise((resolve) => setTimeout(resolve, 50))
  }
  return false
}
